export class URLParamsBuilder {
  private readonly url: string;
  private queryParams: { [key: string]: any };

  constructor(url: string) {
    this.url = url;
  }

  addQueryParams(params: { [key: string]: any }) {
    this.queryParams = params;
    return this;
  }

  build(): string {
    if (!this.queryParams) {
      return this.url;
    }
    const queryParamsArr = [];
    const keys = Object.keys(this.queryParams);
    for (const key of keys) {
      const value = this.queryParams[key];

      if (value != null) {
        const queryParam =
          `${encodeURIComponent(key)}=` +
          `${encodeURIComponent(String(value))}`;

        queryParamsArr.push(queryParam);
      }
    }
    return `${this.url}?` + queryParamsArr.join('&');
  }
}
